import {createFileRoute} from '@tanstack/react-router';
import {BonusCheckRouter} from 'features/bonus-checks/components/BonusCheckRouter';

export const Route = createFileRoute(
  '/_protected/home/accounts/credits/$accountId/bonus-checks',
)({
  component: BonusCheckRouter,
  validateSearch: (search: {
    presentationMode?: 'PDF';
    filter?: 'OLD' | 'ACTIVE';
  }) => {
    return {
      presentationMode: search.presentationMode,
      filter: search.filter,
    };
  },
});
